$(function () {
    if (typeof isFlyerPageRequest !== 'undefined' && isFlyerPageRequest) {
        AsyncLoadCoupons.start();
    }
});